/* istanbul ignore file */
import { configStore } from '@vfde-fe/sails_core';

import InitWebchatUi from 'Container/Ui/index';

const store = configStore({});

InitWebchatUi();
